(function() {

  'use strict';

  function stringCorreios($sce) {
    return function(text) {
      return $sce.trustAsHtml(text);
    }

  };

  angular
    .module('mandaeApp')
    .filter('stringCorreios', stringCorreios)

})();
